
function analyticsManager(config = {}) {
    const plugins = config.plugins;

    const createTrackPayload = (eventName, payload, projectContext) => ({
        event: eventName,
        properties: payload,
        projectContext,
    });

    const resolvePlugins = (pluginNames = []) => {
        return plugins.filter(plugin => pluginNames.includes(plugin.name));
    };

    const instance = {
        track: (eventName, payload, projectContext) => {
            const trackPayload = createTrackPayload(eventName, payload, projectContext);

            plugins.forEach(plugin => {
                plugin.track(trackPayload);
            });
        },
        trackTo: (pluginNames, eventName, payload, projectContext) => {
            const trackPayload = createTrackPayload(eventName, payload, projectContext);

            resolvePlugins(pluginNames).forEach(({ trackTo, track }) => {
                typeof trackTo === 'function' ? trackTo(trackPayload) : track(trackPayload);
            });
        },
    };

    return instance;
}

export { analyticsManager };